// Curated Tailwind color palette for the color picker preset swatches
// ~10 hues x 4 shades + neutrals = ~45 colors
export const TAILWIND_PALETTE: string[] = [
  // slate
  '#f8fafc', '#94a3b8', '#475569', '#1e293b',
  // red
  '#fee2e2', '#f87171', '#dc2626', '#991b1b',
  // orange
  '#ffedd5', '#fb923c', '#ea580c', '#9a3412',
  // amber/yellow
  '#fef9c3', '#fbbf24', '#d97706', '#92400e',
  // green
  '#dcfce7', '#4ade80', '#16a34a', '#166534',
  // teal
  '#ccfbf1', '#2dd4bf', '#0d9488', '#115e59',
  // blue
  '#dbeafe', '#60a5fa', '#2563eb', '#1e40af',
  // indigo
  '#e0e7ff', '#818cf8', '#4f46e5', '#3730a3',
  // purple
  '#ede9fe', '#a78bfa', '#7c3aed', '#5b21b6',
  // pink/rose
  '#fce7f3', '#f472b6', '#db2777', '#9d174d',
  // neutral
  '#ffffff', '#f3f4f6', '#6b7280', '#1f2937', '#000000',
];
